import { render, staticRenderFns } from "./Libao.vue?vue&type=template&id=1a7fbb98&scoped=true"
import script from "./Libao.vue?vue&type=script&lang=ts"
export * from "./Libao.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./Libao.vue?vue&type=style&index=0&id=1a7fbb98&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "1a7fbb98",
  "0e48a6b0"
  
)

export default component.exports